import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../config/axios"
import axios from "axios";
import TimelineItem from "../../components/Timeline";
import { ToastContainer, toast } from "react-toastify";
import { Documentdetails, EducationdetailsAdd, PersonaldetailsAdd, WorkexperienceAdd } from "../../components/career/CareerComponent";
import GoodJob from '../../assets/gif/thumbsUp.gif'
import { handleErrorToast } from "../CustomFunctions";
import { AddwithBlueCircle } from "../AllSvg";


const PersonaldetailsProfile = () => {
  let { email } = useParams();

  const navigate = useNavigate()

  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }

  return (
    <div className="jd">
      <div className="jd-timeline">
        <button onClick={route_Personal_details}>
          <TimelineItem heading="Personal Information" color="#2576BC" />
        </button>
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Education_details}>
          <TimelineItem heading="Education Detail" color="#707070" />
        </button>
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Work_details}>
          <TimelineItem heading="Work Experience" color="#707070" />
        </button>
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Emergency_details}>
          <TimelineItem heading="Emergency Contact" color="#707070" />
        </button>
        {/* <div className="jd-timeline-borderr width-5vw"></div> */}
        {/* <button onClick={route_Account_details}>
          <TimelineItem heading="Account Details" color="#707070" />
        </button> */}
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Document_details}>
          <TimelineItem heading="Documents Upload" color="#707070" />
        </button>
      </div>

      <PersonaldetailsAdd email={email} forwardroutepath="educationDetailss" />
    </div>
  );
};



const PersonaldetailsEducationdetails = () => {
  let { email } = useParams();

  const navigate = useNavigate()

  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }

  return (
    <div className="jd">
      <div className="jd-timeline">
        <button onClick={route_Personal_details}>
          <TimelineItem heading="Personal Information" color="#2576BC" />
        </button>
        <div className="jd-timeline-borderr timeline-color"></div>
        <button onClick={route_Education_details}>
          <TimelineItem heading="Education Detail" color="#2576BC" />
        </button>
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Work_details}>
          <TimelineItem heading="Work Experience" color="#707070" />
        </button>
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Emergency_details}>
          <TimelineItem heading="Emergency Contact" color="#707070" />
        </button>
        {/* <div className="jd-timeline-borderr width-5vw"></div> */}
        {/* <button onClick={route_Account_details}>
          <TimelineItem heading="Account Details" color="#707070" />
        </button> */}
        <div className="jd-timeline-borderr width-5vw"></div>
        <button onClick={route_Document_details}>
          <TimelineItem heading="Documents Upload" color="#707070" />
        </button>
      </div>

      <EducationdetailsAdd email={email} forwardroutepath="workexperiencee" backroutepath="personalDetailss" />
    </div>
  );
};



const Personaldetailsworkexprience = () => {
  let { email } = useParams()

  const navigate = useNavigate()

  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }

  return (

    <>

      <div className="jd">

        <div className="jd-timeline">
          <button onClick={route_Personal_details}>
            <TimelineItem heading="Personal Information" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Education_details}>
            <TimelineItem heading="Education Detail" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Work_details}>
            <TimelineItem heading="Work Experience" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr width-5vw"></div>
          <button onClick={route_Emergency_details}>
            <TimelineItem heading="Emergency Contact" color="#707070" />
          </button>
          {/* <div className="jd-timeline-borderr width-5vw"></div> */}
          {/* <button onClick={route_Account_details}>
            <TimelineItem heading="Account Details" color="#707070" />
          </button> */}
          <div className="jd-timeline-borderr width-5vw"></div>
          <button onClick={route_Document_details}>
            <TimelineItem heading="Documents Upload" color="#707070" />
          </button>
        </div>

        <WorkexperienceAdd email={email} forwardroutepath="emergencycontacts" backroutepath="educationDetailss" />
      </div>

    </>
  );
};


const PersonaldetailsEmergencycontactdetails = () => {
  let { email } = useParams()
  const [inputFields, setInputFields] = useState([
    { person_name: "", phone_number: "", relation: "", user: email },
  ]);
  const [errors, setErrors] = useState({});

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFields = [...inputFields];
    updatedFields[index][name] = value;
    setInputFields(updatedFields);
  };

  const handleAddInputField = () => {
    setInputFields([
      ...inputFields,
      { person_name: "", phone_number: "", relation: "", user: email },
    ]);
  };

  const handleRemoveInputField = (index) => {
    const updatedFields = [...inputFields];
    updatedFields.splice(index, 1);
    setInputFields(updatedFields);
  };

  const validateForm = () => {
    const newErrors = {};
    inputFields.forEach((field, index) => {
      const requiredFields = [
        "person_name",
        "phone_number",
        "relation"

      ];
      requiredFields.forEach((reqField) => {
        if (!field[reqField]) {
          newErrors[`${reqField}_${index}`] = `${reqField.charAt(0).toUpperCase() + reqField.slice(1)
            } is required!`;
        }
      });
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const navigate = useNavigate()
  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }

  const backroute = () => {
    navigate(`/workexperiencee/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`)
  }
  const forwardroute = () => {
    // navigate(`/accountdetailss/${email}/`)
    navigate(`/documentdetailss/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`)
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.post(`${BASE_URL}/userdata/userEmergencyContactall/`, inputFields,)

        if (res.status === 200) {
          // navigate(`/accountdetailss/${email}/`)
          forwardroute()
          // navigate(`/accountdetailss/${email}/`, { state: { empCode } })
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };


  const handleFormPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        await Promise.all(
          inputFields.map(async (educationDetail) => {
            if (educationDetail.id) {
              await axios.put(`${BASE_URL}/userdata/userEmergencyContact/${educationDetail.id}/`, educationDetail);
            } else {
              await axios.post(`${BASE_URL}/userdata/userEmergencyContact/`, educationDetail);
            }
          })
        );

        // navigate(`/accountdetailss/${email}/`)
        forwardroute()
        // navigate(`/accountdetailss/${email}/`, { state: { empCode } })
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);

      }
    }
  };


  const [buffer, setBuffering] = useState(true); //buffering logic

  const [data, setData] = useState(false)




  useEffect(() => {
    // const storedUserData = Cookies.get("userData");

    const getUSerDetails = async () => {
      setBuffering(true); //buffering logic // Start Buffering
      try {
        const res = await axios.get(`${BASE_URL}/userdata/userEmergencyContactallget/${email}/`);
        if (res.data.length > 0) {
          setInputFields(res.data);
          setData(true)
        }
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setBuffering(false);// End Buffering
      }
    };

    getUSerDetails();
  }, []);



  return (
    <>
      {buffer ? <div className="spinner-z"></div> : null}{/* //buffering logic */}
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="jd">

        <div className="jd-timeline">
          <button onClick={route_Personal_details}>
            <TimelineItem heading="Personal Information" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Education_details}>
            <TimelineItem heading="Education Detail" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Work_details}>
            <TimelineItem heading="Work Experience" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Emergency_details}>
            <TimelineItem heading="Emergency Contact" color="#2576BC" />
          </button>
          {/* <div className="jd-timeline-borderr width-5vw"></div> */}
          {/* <button onClick={route_Account_details}>
            <TimelineItem heading="Account Details" color="#707070" />
          </button> */}
          <div className="jd-timeline-borderr width-5vw"></div>
          <button onClick={route_Document_details}>
            <TimelineItem heading="Documents Upload" color="#707070" />
          </button>
        </div>

        <div className="jd-heading-outer">
          <div className="jd-heading-outer-flex">
            <h2 className="jd-heading-main font-weight600  font-size-heading">Emergency Contact Details *</h2>

            <h2 className="jd-heading-main font-weight600 -right font-size-text ">
              Please click here to add more{" "}
              <button
                type="button"
                onClick={handleAddInputField}
                className="jd-heading-main font-weight600 -right-button"
              >
                <AddwithBlueCircle />
              </button>
            </h2>
          </div>
          <div>
            <div className="jd-heading-bottom-bold"></div>
            <div className="jd-heading-bottom-light"></div>
          </div>
        </div>

        <form className="register-form" >
          {inputFields.map((field, index) => (
            <div key={index} className="form-flex-wrap">
              <div className="flex-column">
                <label htmlFor={`person_name_${index}`} className="form-labels  font-weight500    font-size-subheading">
                  Preson Name {index + 1}<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id={`person_name_${index}`}
                  name="person_name"
                  value={field.person_name}
                  onChange={(e) => handleChange(index, e)}
                  className={`form-input ${errors[`person_name_${index}`]
                    ? "error"
                    : field.person_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors[`person_name_${index}`] && (
                  <span className="error-message font-size-text ">
                    {errors[`person_name_${index}`]}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor={`phone_number_${index}`} className="form-labels  font-weight500    font-size-subheading">
                  Phone number<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id={`phone_number_${index}`}
                  name="phone_number"
                  value={field.phone_number}
                  onChange={(e) => handleChange(index, e)}
                  className={`form-input ${errors[`phone_number_${index}`]
                    ? "error"
                    : field.phone_number
                      ? "success"
                      : ""
                    }`}
                />
                {errors[`phone_number_${index}`] && (
                  <span className="error-message font-size-text ">
                    {errors[`phone_number_${index}`]}
                  </span>
                )}
              </div>


              <div className="flex-column">
                <label htmlFor={`relation_${index}`} className="form-labels  font-weight500    font-size-subheading">
                  Relation<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id={`relation_${index}`}
                  name="relation"
                  value={field.relation}
                  onChange={(e) => handleChange(index, e)}
                  className={`form-input ${errors[`relation_${index}`]
                    ? "error"
                    : field.relation
                      ? "success"
                      : ""
                    }`}
                />
                {errors[`relation_${index}`] && (
                  <span className="error-message font-size-text ">
                    {errors[`relation_${index}`]}
                  </span>
                )}
              </div>

              <div className="flex-column"></div>

              <div>
                {index > 0 ? (
                  <button
                    type="button"
                    onClick={() => handleRemoveInputField(index)}
                    className="remove-button   font-weight500    font-size-heading"
                  >
                    Remove
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          ))}
          <div className="button-models">
            <button className="model-button model-button-cancel  font-weight500   " onClick={backroute}>Back</button>
            {data ? (<button onClick={handleFormPut} className="model-button   font-weight500    model-button-submit">
              Next
            </button>) : (<button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit">
              Next
            </button>)}
          </div>
        </form>
      </div>
    </>
  );
};



const PersonaldetailsAccountdetails = () => {

  let { email } = useParams()

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [empCode, setEmpCode] = useState()
  const getCompanyDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemail/${email}/`);
      setEmpCode(res.data.emp_code)
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  // useEffect(() => {

  const [formData, setFormData] = useState({

    account_number: "",
    ifsc_code: "",
    bank_name: "",
    branch_address: "",
    user: empCode
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      // "pan_name",
      // "father_name_pan",
      // "pan_dob",
      // "pan_no",
      "bank_name",
      // "name_require",
      "account_number",
      "ifsc_code",
      "branch_address"


    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //


  const navigate = useNavigate()

  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }

  const backroute = () => {
    navigate(`/emergencycontacts/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`)
  }

  const forwardroute = () => {
    navigate(`/documentdetailss/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`)
  }


  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      // Cookies.set("userData", JSON.stringify(formData));
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      const updatedFormData = {
        ...formData,
        user: empCode
        // employee: formData.email,
      };


      try {
        let res = await axios.post(`${BASE_URL}/wfm/userBankDetails/`, updatedFormData)

        if (res.status === 200) {
          // navigate(`/documentdetailss/${email}/`)
          forwardroute()
          // window.location.reload();
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)

      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);

      }
    }
  };

  const handleFormPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(`${BASE_URL}/wfm/userBankDetails/${empCode}/`, formData,)

        if (res.status === 200) {
          // navigate(`/documentdetailss/${email}/`)
          forwardroute()
          // window.location.reload();
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)

      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };


  const [data, setData] = useState(false)
  useEffect(() => {
    const getUSerDetails = async () => {
      setBuffering(true); //buffering logic // Start Buffering
      try {
        const res = await axios.get(`${BASE_URL}/wfm/userBankDetailsgetall/${empCode}/`);
        setFormData(res.data);
        setData(true)
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setBuffering(false);// End Buffering
      }
    };

    getCompanyDetails();
    getUSerDetails();
  }, [empCode]);


  return (
    <>
      {buffer ? <div className="spinner-z"></div> : null}{/* //buffering logic */}
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="jd">

        <div className="jd-timeline">
          <button onClick={route_Personal_details}>
            <TimelineItem heading="Personal Information" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Education_details}>
            <TimelineItem heading="Education Detail" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Work_details}>
            <TimelineItem heading="Work Experience" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Emergency_details}>
            <TimelineItem heading="Emergency Contact" color="#2576BC" />
          </button>
          {/* <div className="jd-timeline-borderr timeline-color"></div> */}
          {/* <button onClick={route_Account_details}>
            <TimelineItem heading="Account Details" color="#2576BC" />
          </button> */}
          <div className="jd-timeline-borderr width-5vw"></div>
          <button onClick={route_Document_details}>
            <TimelineItem heading="Documents Upload" color="#707070" />
          </button>
        </div>

        <div className="jd-heading-outer">
          <h2 className="jd-heading-main font-weight600  font-size-heading">Account Details*</h2>
          <div>
            <div className="jd-heading-bottom-bold"></div>
            <div className="jd-heading-bottom-light"></div>
          </div>
        </div>

        <form className="register-form">
          <div className="form-flex-wrap">

            <div className="flex-column">
              <label htmlFor="bank_name" className="form-labels  font-weight500    font-size-subheading">
                Bank Name<span className="required">*</span>
              </label>
              <input
                type="write"
                id="bank_name"
                name="bank_name"
                maxLength={60}
                placeholder="Bank name"
                onChange={handleInputChange}
                value={formData.bank_name}
                className={`form-input ${errors.bank_name ? "error" : inputState.bank_name ? "success" : ""
                  }`}
              />
              {errors.bank_name && (
                <span className="error-message font-size-text ">{errors.bank_name}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor="branch_address" className="form-labels  font-weight500    font-size-subheading">
                Branch address<span className="required">*</span>
              </label>
              <input
                type="write"
                id="branch_address"
                name="branch_address"
                maxLength={100}
                placeholder="Bank Address"
                onChange={handleInputChange}
                value={formData.branch_address}
                className={`form-input ${errors.branch_address ? "error" : inputState.branch_address ? "success" : ""
                  }`}
              />
              {errors.branch_address && (
                <span className="error-message font-size-text ">{errors.branch_address}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor="account_number" className="form-labels  font-weight500    font-size-subheading">
                Account Number<span className="required">*</span>
              </label>
              <input
                type="text"
                // type="number"
                id="account_number"
                name="account_number"
                maxLength={20}
                placeholder="1234 1234 1234"
                onChange={handleInputChange}
                value={formData.account_number}
                className={`form-input ${errors.account_number ? "error" : inputState.account_number ? "success" : ""
                  }`}
              />
              {errors.account_number && (
                <span className="error-message font-size-text ">{errors.account_number}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor="ifsc_code" className="form-labels  font-weight500    font-size-subheading">
                IFSC Code<span className="required">*</span>
              </label>
              <input
                type="text"
                id="ifsc_code"
                name="ifsc_code"
                placeholder="AAAAA1234A"
                maxLength={15}
                onChange={handleInputChange}
                value={formData.ifsc_code}
                className={`form-input ${errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""
                  }`}
              />
              {errors.ifsc_code && (
                <span className="error-message font-size-text ">{errors.ifsc_code}</span>
              )}
            </div>
          </div>

          <div className="button-models">
            <button className="model-button model-button-cancel  font-weight500   " onClick={backroute}>Back</button>
            {data ? (<button onClick={handleFormPut} className="model-button   font-weight500    model-button-submit" disabled={loading}>
              Update
            </button>) : (<button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit" disabled={loading}>
              Next
            </button>)}
          </div>
        </form>
      </div>
    </>
  );
};

const PersonaldetailsDocumentdetails = () => {

  let { id, email } = useParams()

  const navigate = useNavigate()

  let path_Personal_details = "personalDetailss"
  let path_Education_details = "educationDetailss"
  let path_Work_details = "workexperiencee"
  let path_Emergency_details = "emergencycontacts"
  let path_Account_details = "accountdetailss"
  let path_Document_details = "documentdetailss"

  const route_Personal_details = () => {
    navigate(`/${path_Personal_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Education_details = () => {
    navigate(`/${path_Education_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Work_details = () => {
    navigate(`/${path_Work_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Emergency_details = () => {
    navigate(`/${path_Emergency_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Account_details = () => {
    navigate(`/${path_Account_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  const route_Document_details = () => {
    navigate(`/${path_Document_details}/${email}/?company_id=${sessionStorage.getItem("company_id") || "null"}`);
  }
  return (
    <>
      <div className="jd">

        <div className="jd-timeline">
          <button onClick={route_Personal_details}>
            <TimelineItem heading="Personal Information" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Education_details}>
            <TimelineItem heading="Education Detail" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Work_details}>
            <TimelineItem heading="Work Experience" color="#2576BC" />
          </button>
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Emergency_details}>
            <TimelineItem heading="Emergency Contact" color="#2576BC" />
          </button>
          {/* <div className="jd-timeline-borderr timeline-color"></div> */}
          {/* <button onClick={route_Account_details}>
            <TimelineItem heading="Account Details" color="#2576BC" />
          </button> */}
          <div className="jd-timeline-borderr timeline-color"></div>
          <button onClick={route_Document_details}>
            <TimelineItem heading="Documents Upload" color="#2576BC" />
          </button>
        </div>

        {/* <Documentdetails email={email} backroutepath="accountdetailss" /> */}
        <Documentdetails email={email} backroutepath="emergencycontacts" />
      </div>
    </>
  );
};


const CompletePage = () => {
  return (
    <>
      <center>
        <br /><br /><br /><br /><br /><br /><br /><br /><h3>
          <br /><b>Process Completed, </b> <br />You can close the tab 👍<br /><br />
          <img style={{ borderRadius: "20px", boxShadow: "0px 1px 38px 0px rgba(0, 0, 0, 0.10)" }} src={GoodJob} alt="" />
        </h3>
      </center>
    </>
  );
};


export { PersonaldetailsProfile, PersonaldetailsEducationdetails, Personaldetailsworkexprience, PersonaldetailsEmergencycontactdetails, PersonaldetailsAccountdetails, PersonaldetailsDocumentdetails, CompletePage }
